import React, {useEffect, useRef, useState} from 'react';
import {useHistory, useLocation} from "react-router-dom";
import './NationalCPC.page.css';
import {
    Autocomplete,
    Box,
    Button,
    Divider,
    Grid,
    keyframes,
    Link,
    Skeleton,
    TextField,
    Typography
} from "@mui/material";
import backgroundImage from "../../assets/images/Bg_2.jpg";
import Icon1 from "../../assets/images/icon1.png";
import Icon2 from "../../assets/images/icon2.png";
import Icon3 from "../../assets/images/icon3.png";
import Icon4 from "../../assets/images/icon4.png";
import SHicon1 from "../../assets/images/stakeholders_icons/slice1.png";
import SHicon2 from "../../assets/images/stakeholders_icons/slice2.png";
import SHicon3 from "../../assets/images/stakeholders_icons/slice3.png";
import SHicon4 from "../../assets/images/stakeholders_icons/slice4.png";
import SHicon5 from "../../assets/images/stakeholders_icons/slice5.png";
import SHicon6 from "../../assets/images/stakeholders_icons/slice6.png";
import SHicon7 from "../../assets/images/stakeholders_icons/slice7.png";
import RadarChart from "./RadarChart.comp";
import MixedChart from "./MixedChart.comp";
import {countries} from "../../utils/Countries";
import {
    countryCodesByAllIndexesService,
    getCompetenciesIndexDataService,
    getDigitalGapsIndexDataService,
    getGoalsIndexDataService,
    getGoalsPointsIndexDataService,
    getTargetsIndexDataService
} from "../../services/elevate_cpc.service";
import CPCITable from "./CPCITable.comp";
import {
    AGE_GROUPS,
    AGE_GROUPS_MAPPING,
    DEFAULT_COUNTRIES,
    GLOBAL_COUNTRY_CODE,
    GRADE_COLOR_MAPPING,
    METADATA_KEY, STAKEHOLDERS_CATEGORY_COLOR_MAPPING,
} from "../../utils/constants";
import Footer from "../Methodology/Footer";

const NationalCPC = () => {
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [nationCpciData, setNationCpciData] = useState({
        labels: [
            "Child Cyber-Behaviours",
            'Family support',
            'School education',
            'ICT company responsibility',
            'Policies and regulations',
            'Technology infrastructure',
        ],
        datasets: [
            {
                label: 'Global Average',
                data: [4, 3, 5, 4, 2, 4],
                backgroundColor: 'rgba(240, 96, 92, 0.2)',
                borderColor: '#F0605C',
                pointBackgroundColor: '#F0605C',
                pointBorderColor: '#F0605C',
                borderWidth: 2,
                borderRadius: 0,
                fill: true,
            },
            {
                label: 'Name of Country Average',
                data: [3, 4, 4, 3, 3, 5],
                backgroundColor: 'rgba(0, 60, 105, 0.3)',
                borderColor: '#003C69',
                pointBackgroundColor: '#003C69',
                borderWidth: 2,
                fill: true,
            },
        ],
    });

    // First Chart States (With Reduction Percentage)
    const [digitalGapsCountries, setDigitalGapsCountries] = useState([]);
    const [selectedCountryA1, setSelectedCountryA1] = useState(DEFAULT_COUNTRIES['SG']);
    const [selectedCountryB1, setSelectedCountryB1] = useState(DEFAULT_COUNTRIES['AU']);
    const [reductionPercentage, setReductionPercentage] = useState(10);
    const [selectedAgeGroup, setSelectedAgeGroup] = useState('8-12 Years old');
    const [goalsData, setGoalsData] = useState({});
    const [selectedCountryA1OverAllCyberRisk, setSelectedCountryA1OverAllCyberRisk] = useState(0)

    // Second Chart States
    const [cyberCitizenshipCountries, setCyberCitizenshipCountries] = useState([]);
    const [selectedCountryA2, setSelectedCountryA2] = useState(DEFAULT_COUNTRIES['SG']);
    const [selectedCountryB2, setSelectedCountryB2] = useState(DEFAULT_COUNTRIES['AU']);
    const [selectedAgeGroup2, setSelectedAgeGroup2] = useState('8-12 Years old');
    const [cyberCitizenshipData, setCyberCitizenshipData] = useState({});
    const [selectedCountryA2Avg, setSelectedCountryA2Avg] = useState();
    const [selectedCountryB2Avg, setSelectedCountryB2Avg] = useState();
    const [globalAvg2, setGlobalAvg2] = useState();

    // Section 3
    const [selectedCountryA3, setSelectedCountryA3] = useState(DEFAULT_COUNTRIES['SG']);
    const [cpciTableData, setCPCITableData] = useState([]);
    const [cpciCountries, setCPCICountries] = useState([]);

    // Section 4
    const [targetCountries, setTargetCountries] = useState([]);

    const [mixedChartData1, setMixedChartData1] = useState({
        labels: goalsData?.labels ? goalsData.labels.map(label => label.split(" ")) : [],
        datasets: [
            {label: "", data: [], backgroundColor: "#003C69", borderRadius: 0, order: 1, stack: "Stack 1"},
            // {label: "", data: [], backgroundColor: "#0096C8", borderRadius: 20, order: 2, stack: "Stack 2"},
            {label: "", data: [], backgroundColor: "#0096C8", borderRadius: 0, order: 3, stack: "Stack 2"},
            {
                label: "Global Average",
                data: [],
                type: "line",
                borderColor: "#F05F64",
                backgroundColor: "#F05F64",
                borderWidth: 2,
                tension: 0,
                fill: false,
                order: 0,
                pointStyle: "circle",
                pointRadius: 5,
                pointHoverRadius: 7
            },
        ],
    });
    const [mixedChartData2, setMixedChartData2] = useState({
        labels: cyberCitizenshipData?.labels ? cyberCitizenshipData.labels.map(label => label.split(" ")) : [],
        datasets: [
            {label: "", data: [], backgroundColor: "#003C69", borderRadius: 0, order: 1, stack: "Stack 1"},
            {label: "", data: [], backgroundColor: "#0096C8", borderRadius: 0, order: 2, stack: "Stack 2"},
            {
                label: "Global",
                data: [],
                type: "line",
                borderColor: "#F05F64",
                backgroundColor: "#F05F64",
                borderWidth: 2,
                tension: 0,
                fill: false,
                order: 0,
                pointStyle: "circle",
                pointRadius: 5,
                pointHoverRadius: 7
            },
        ],
    });

    const didFetchCountryCodesAll = useRef(false);

    const handleCountryChange = (newValue, country, chart) => {
        if (chart === 1) {
            if (newValue)
                country === "A" ? setSelectedCountryA1(newValue) : setSelectedCountryB1(newValue);
        } else {
            country === "A" ? setSelectedCountryA2(newValue) : setSelectedCountryB2(newValue);
        }
    };

    const handleCountryChangeCPCI = (newValue) => {
        if(newValue)
            setSelectedCountryA3(newValue);
    };

    useEffect(() => {
        if (didFetchCountryCodesAll.current) return;
        didFetchCountryCodesAll.current = true;
        const fetchData = async () => {
            try {
                const {data} = await countryCodesByAllIndexesService();
                if (data && data.codes) {
                    const {competencies, digitalGaps, goals, targets} = data.codes;

                    const filteredCyberCitizenshipCountries = countries.filter(country =>
                        competencies.includes(country.code)
                    );
                    const filteredDigitalGapsCountries = countries.filter(country =>
                        digitalGaps.includes(country.code)
                    );
                    const filteredCPCICountries = countries.filter(country =>
                        goals.includes(country.code)
                    );
                    const filteredTargetCountries = countries.filter(country =>
                        targets.includes(country.code)
                    );
                    setCyberCitizenshipCountries(filteredCyberCitizenshipCountries);
                    setDigitalGapsCountries(filteredDigitalGapsCountries);
                    setCPCICountries(filteredCPCICountries);
                    setTargetCountries(filteredTargetCountries);
                }
            } catch (e) {
                console.error(e);
            }
        };
        fetchData();
    }, []);

    const getAverageFromData = (data) => {
        const numericValues = Object.values(data)
            .filter(value => typeof value === 'number' || value === null)
            .map(value => value === null || Number.isNaN(value) ? 0 : value);
        if (numericValues.length === 0) {
            return 0;
        }
        const sum = numericValues.reduce((total, num) => total + num, 0);
        return (sum / numericValues.length).toFixed(2);
    };

// For Chart 1 (no reduction)
    useEffect(() => {
        if (!goalsData || !goalsData.labels) {
            return;
        }

        const formattedLabels = goalsData.labels.map(label => label.split(" "));
        const defaultCountryA1 = goalsData.countries.length > 0 ? goalsData.countries[0] : {
            label: "Singapore",
            data: [30, 25, 35, 40, 45, 50, 55, 60]
        };
        const defaultCountryB1 = goalsData.countries.length > 1 ? goalsData.countries[1] : {
            label: "France",
            data: [25, 20, 30, 35, 40, 45, 50, 55]
        };
        const updatedChart1Data = {
            ...mixedChartData1,
            datasets: mixedChartData1?.datasets || [{}, {}, {}],
            labels: formattedLabels,
        };

        // Country A (from API or fallback)
        if (goalsData.countries[0] && goalsData.countries[0].data && Array.isArray(goalsData.countries[0].data)) {
            updatedChart1Data.datasets[0].data = goalsData.countries[0].data;
            updatedChart1Data.datasets[0].label = goalsData.countries[0].label;
        } else {
            updatedChart1Data.datasets[0].data = defaultCountryA1.data;
            updatedChart1Data.datasets[0].label = defaultCountryA1.label;
        }
        updatedChart1Data.datasets[0].backgroundColor = "#003C69"; // Navy blue always

        // Country B (from API or fallback)
        if (goalsData.countries[1] && goalsData.countries[1].data && Array.isArray(goalsData.countries[1].data)) {
            updatedChart1Data.datasets[1].data = goalsData.countries[1].data;
            updatedChart1Data.datasets[1].label = goalsData.countries[1].label;
        } else {
            updatedChart1Data.datasets[1].data = defaultCountryB1.data;
            updatedChart1Data.datasets[1].label = defaultCountryB1.label;
        }
        updatedChart1Data.datasets[1].backgroundColor = "#0096C8"; // Light blue (other country)

        const globalAvgData = goalsData.countries.find(country => country.label === "Global")?.data || [];
        if (!updatedChart1Data.datasets[2]) updatedChart1Data.datasets[3] = {};
        updatedChart1Data.datasets[2].data = globalAvgData;
        updatedChart1Data.datasets[2].label = "Global Average";
        setMixedChartData1(updatedChart1Data);
    }, [selectedCountryA1, selectedCountryB1, goalsData]);

// For Chart 2 (no reduction)
    useEffect(() => {
        if (!cyberCitizenshipData || !cyberCitizenshipData.labels) {
            return;
        }

        const updatedChart2Data = {
            ...mixedChartData2,
            datasets: [...mixedChartData2.datasets],
            labels: cyberCitizenshipData.labels
        };

        const defaultCountryA2 = cyberCitizenshipData?.countries?.length > 0
            ? cyberCitizenshipData.countries[0]
            : {label: "Singapore", data: [30, 25, 35, 40, 45, 50, 55, 60, 25, 35, 40, 45, 50, 55, 60]};

        const defaultCountryB2 = cyberCitizenshipData?.countries?.length > 1
            ? cyberCitizenshipData.countries[1]
            : {label: "France", data: [25, 20, 30, 35, 40, 45, 50, 55, 25, 35, 40, 45, 50, 55, 60]};

        updatedChart2Data.datasets[0] = {
            ...updatedChart2Data.datasets[0],
            data: cyberCitizenshipData.countries[0]?.data && Array.isArray(cyberCitizenshipData.countries[0].data) ? cyberCitizenshipData.countries[0].data : defaultCountryA2.data,
            label: cyberCitizenshipData.countries[0]?.label || selectedCountryA2.label || defaultCountryA2.label,
        };

        if (updatedChart2Data.datasets[1]) {
            updatedChart2Data.datasets[1] = {
                ...updatedChart2Data.datasets[1],
                data: cyberCitizenshipData.countries[1]?.data && Array.isArray(cyberCitizenshipData.countries[1].data) ? cyberCitizenshipData.countries[1].data : defaultCountryB2.data,
                label: cyberCitizenshipData.countries[1]?.label || selectedCountryB2.label || defaultCountryB2.label,
            };
        }

        //Averages
        setSelectedCountryA2Avg(getAverageFromData(cyberCitizenshipData.countries[0].data));
        setSelectedCountryB2Avg(getAverageFromData(cyberCitizenshipData.countries[1].data));
        setGlobalAvg2(getAverageFromData(cyberCitizenshipData.countries[2].data));

        const globalAvgData = cyberCitizenshipData?.countries?.find(country => country.label === "Global")?.data || [];
        updatedChart2Data.datasets[2] = {
            label: "Global Average",
            data: globalAvgData,
            type: "line",
            borderColor: "#F05F64",
            backgroundColor: "#F05F64",
            borderWidth: 2,
            tension: 0,
            fill: false,
            order: 0,
            pointStyle: "circle",
            pointRadius: 5,
            pointHoverRadius: 7,
        };
        //console.log("🌍 Global Dataset Added for chart 2:", updatedChart2Data.labels);
        setMixedChartData2(updatedChart2Data);
    }, [selectedCountryA2, selectedCountryB2, cyberCitizenshipData]);

    const handleAgeGroupChange = (event, newValue) => {
        if (newValue) {
            setSelectedAgeGroup(newValue);
            const ageGroupForDB = AGE_GROUPS_MAPPING[newValue];
            console.log('Age group:', ageGroupForDB);
        }
    };

    const handleAgeGroupChange2 = (event, newValue) => {
        if (newValue)
            setSelectedAgeGroup2(newValue);
    };

    const [stakeholdersData, setStakeHoldersData] = useState([
        {
            title: '', //'Child Cyber Behaviours',
            icon: SHicon1,
            rows: [
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
            ],
        },
        {
            title: '', //'Cyber-Competent Children',
            icon: SHicon2,
            rows: [
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
            ],
        },
        {
            title: '', //'Empowered Families',
            icon: SHicon3,
            rows: [
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
            ],
        },
        {
            title: '', //'Cyber-Safe Schools',
            icon: SHicon4,
            rows: [
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
            ],
        },
        {
            title: '', // 'Responsible Companies',
            icon: SHicon5,
            rows: [
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
            ],
        },
        {
            title: '', //'Protective Governments',
            icon: SHicon6,
            rows: [
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
            ],
        },
        {
            title: '', //'Secure Tech Infrastructure',
            icon: SHicon7,
            rows: [
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
                {text: '', circleColor: ''},
            ],
        },
    ]);

    const transformToChartsData = (responses, metaDataKey) => {
        const labels = Object.keys(responses[0].metaData)
            .filter(key => key !== "expe_CyberRisks")
            .map(
                (key) => responses[0].metaData[key][metaDataKey].trim().replace(/\\n|\r/g, " ")
            );

        if (metaDataKey === METADATA_KEY.GOAL_CHART) {
            const expeCyberRisksValue = responses[0].indexData["expe_CyberRisks"]
                ? Math.round(responses[0].indexData["expe_CyberRisks"] * 100)
                : 0;
            setSelectedCountryA1OverAllCyberRisk(expeCyberRisksValue === 0 ? "NA" : expeCyberRisksValue);
        }

        const countries = responses.map((response) => {
            const label = response.indexData.country_name;

            const data = Object.keys(response.metaData)
                .filter(key => key !== "expe_CyberRisks")
                .map((key) =>
                    response.indexData[key] ? Math.round(response.indexData[key] * 100) : 0 //TODO
                );

            return {label, data};
        });

        return {labels, countries};
    };

    useEffect(() => {
        getDigitalGapsIndexData().then(r => console.log("Digital Gaps Data Fetching Started"));
    }, [selectedCountryA1?.code, selectedCountryB1?.code, selectedAgeGroup]);

    useEffect(() => {
        getCompetenciesIndexData().then(r => console.log("Competencies Data Fetching Started"));
    }, [selectedCountryA2?.code, selectedCountryB2?.code, selectedAgeGroup2]);

    useEffect(() => {
        getGoalsIndexData().then(r => console.log("Goals Data Fetching Started"));
        getGoalsPointsIndexData().then(r => console.log("Goals Points Data Fetching Started"));
        getTargetsIndexData().then(r => console.log("Targets Data Fetching Started"));
    }, [selectedCountryA3?.code]);

    const getCompetenciesIndexData = async () => {
        try {
            setLoading(true);
            const response_c1 = await getCompetenciesIndexDataService(selectedCountryA2.code, AGE_GROUPS_MAPPING[selectedAgeGroup2]);
            const response_c2 = await getCompetenciesIndexDataService(selectedCountryB2.code, AGE_GROUPS_MAPPING[selectedAgeGroup2]);
            const response_c3 = await getCompetenciesIndexDataService(GLOBAL_COUNTRY_CODE, AGE_GROUPS_MAPPING[selectedAgeGroup2]);
            if (response_c1.data && response_c2 && response_c3.data) {
                const transformedData = transformToChartsData([
                    response_c1.data,
                    response_c2.data,
                    response_c3.data,
                ], METADATA_KEY.COMPETENCIES_CHART);
                setCyberCitizenshipData(transformedData);
            }
        } catch (e) {
            // already handled in invokeApi
            setLoading(false);

        } finally {
            setLoading(false);
        }
    }

    const getDigitalGapsIndexData = async () => {
        try {
            setLoading(true);
            const response_c1 = await getDigitalGapsIndexDataService(selectedCountryA1.code, AGE_GROUPS_MAPPING[selectedAgeGroup]);
            const response_c2 = await getDigitalGapsIndexDataService(selectedCountryB1.code, AGE_GROUPS_MAPPING[selectedAgeGroup]);
            const response_c3 = await getDigitalGapsIndexDataService(GLOBAL_COUNTRY_CODE, AGE_GROUPS_MAPPING[selectedAgeGroup]);
            if (response_c1.data && response_c2 && response_c3.data) {
                const transformedData = transformToChartsData([
                    response_c1.data,
                    response_c2.data,
                    response_c3.data,
                ], METADATA_KEY.GOAL_CHART);
                setGoalsData(transformedData);
            }
        } catch (e) {
            // already handled in invokeApi
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const transformToCPCITable = (responses, metaDataKey) => {
        if (!responses || responses.length < 2) {
            return [
                {summary: "Overall CPC Index", country: "A", global: "B"},
                {summary: "Child Cyber-Safety", country: "A", global: "B"},
                {summary: "Competent Children", country: "C", global: "C"},
                {summary: "Empowered Families", country: "A", global: "C"},
                {summary: "Cyber-Safe Schools", country: "C", global: "B"},
                {summary: "Responsible Companies", country: "C", global: "C"},
                {summary: "Protective Governments", country: "D", global: "A"},
                {summary: "Secure Tech Infrastructure", country: "NA", global: "D"},
            ];
        }

        const countryData = responses[0];
        const globalData = responses[1];

        const sortedKeys = Object.keys(countryData.metaData).filter(key => key !== "CPCI_SCORE");

        return [
            {
                summary: "Overall CPC Index",
                country: countryData.indexData["CPCI_SCORE"] || "NA",
                global: globalData.indexData["CPCI_SCORE"] || "NA",
            },
            ...sortedKeys.map((key) => ({
                summary: countryData.metaData[key]?.[metaDataKey]?.trim() || "Unknown",
                country: countryData.indexData[key] || "NA",
                global: globalData.indexData[key] || "NA",
            }))
        ];
    };

    const transformToCPCIChart = (responses, metaDataKey) => {
        const countryData = responses[0];
        const globalData = responses[1];

        const keys = Object.keys(countryData.metaData).filter(key => key !== "CPCI_SCORE");

        const labels = keys.map(
            key => countryData.metaData[key]?.[metaDataKey]?.trim() || "Unknown"
        );

        const countryDataPoints = keys.map(key => countryData.indexData[key] || 0);
        const globalDataPoints = keys.map(key => globalData.indexData[key] || 0);

        return {
            labels,
            datasets: [
                {
                    label: 'Global Average',
                    data: globalDataPoints,
                },
                {
                    label: `${countryData.indexData.country_name} Average`,
                    data: countryDataPoints,
                },
            ],
        };
    };

    const getGoalsIndexData = async () => {
        try {
            setLoading(true);
            const response_c1 = await getGoalsIndexDataService(selectedCountryA3.code);
            const response_c2 = await getGoalsIndexDataService(GLOBAL_COUNTRY_CODE);
            if (response_c1.data && response_c2) {
                const transformedData = transformToCPCITable([
                    response_c1.data,
                    response_c2.data,
                ], METADATA_KEY.CPCI_TABLE);
                setCPCITableData(transformedData);
            }
        } catch (e) {
            // already handled in invokeApi
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const getGoalsPointsIndexData = async () => {
        try {
            setLoading(true);
            const response_c1 = await getGoalsPointsIndexDataService(selectedCountryA3.code);
            const response_c2 = await getGoalsPointsIndexDataService(GLOBAL_COUNTRY_CODE);
            console.log('getGoalsPointsIndexData C1: ', response_c1);
            console.log('getGoalsIndexData C2: ', response_c2);
            if (response_c1.data && response_c2) {
                const transformedData = transformToCPCIChart([
                    response_c1.data,
                    response_c2.data,
                ], METADATA_KEY.CPCI_TABLE);
                setNationCpciData(prevState => ({
                    ...prevState,
                    labels: transformedData.labels,
                    datasets: prevState.datasets.map((dataset, index) => ({
                        ...dataset,
                        label: transformedData.datasets[index].label,
                        data: transformedData.datasets[index].data,
                    })),
                }));
                console.log('getGoalsPointsIndexData Transformed: ', transformedData);
            }
        } catch (e) {
            // already handled in invokeApi
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const transformStakeholdersData = (response1, metaDataKey1, response2, metaDataKey2) => {
        const {indexData, metaData} = response1.data;
        const sortedKeys = Object.keys(response2.data.metaData).filter(key => key !== "CPCI_SCORE");

        const targetKeys = Object.keys(metaData)
            .sort((a, b) => {
                const numA = parseInt(a.replace(/\D/g, ''), 10);
                const numB = parseInt(b.replace(/\D/g, ''), 10);
                return numA - numB;
            });

        const targets = targetKeys.map(key => ({
            targetName: metaData[key][metaDataKey1].trim(),
            grade: indexData[key] || "None"
        }));

        let counter = 0;
        return sortedKeys.map((key, index) => ({
            title: response2.data.metaData[key]?.[metaDataKey2]?.trim(),
            icon: stakeholdersData[index]?.icon,
            rows: stakeholdersData[index]?.rows.map(row => {
                const target = targets[counter++];
                return {
                    ...row,
                    text: target.targetName,
                    circleColor: GRADE_COLOR_MAPPING[target.grade] || GRADE_COLOR_MAPPING['None'],
                };
            }),
            category: index < 3 ? "Empowered Children"
                : index < 5 ? "Safe Technology"
                    : "Protective Policies"
        }));
    };

    const getTargetsIndexData = async () => {
        try {
            setLoading(true);
            const response_c1 = await getTargetsIndexDataService(selectedCountryA3.code);
            const response_c2 = await getGoalsIndexDataService(selectedCountryA3.code);
            if (response_c1 && response_c1.data && response_c2 && response_c2.data) {
                const transformedData = transformStakeholdersData(response_c1, METADATA_KEY.TARGET_TABLE, response_c2, METADATA_KEY.CPCI_TABLE);
                setStakeHoldersData(transformedData);
            }
        } catch (e) {
            // already handled in invokeApi
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (goalsData?.labels) {
            setMixedChartData1(prevState => ({
                ...prevState,
                labels: goalsData.labels.map(label => label.split(" ")), // Wrap labels
            }));
        }

        if (cyberCitizenshipData?.labels) {
            setMixedChartData2(prevState => ({
                ...prevState,
                labels: cyberCitizenshipData.labels.map(label => label.split(" ")),
            }));
        }
    }, [goalsData, cyberCitizenshipData]);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 3000);
        window.scrollTo(0, 0);

        if (location.hash) {
            const hash = location.hash.substring(1);
            const hashTimer = setTimeout(() => {
                const section = document.getElementById(hash);
                if (section) {
                    section.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 500);

            return () => {
                clearTimeout(timer);
                clearTimeout(hashTimer);
            };
        }

        return () => clearTimeout(timer);
    }, [location]);

    return (
        <Box className="root">
            <Box className="elevateHeader" sx={{
                marginTop: {xs:'0px', sm:'80px'},
                background: `url(${backgroundImage}) center/cover no-repeat`,
                backgroundPosition: {
                    xs: '70% center',
                    sm: 'center center',
                },
                backgroundRepeat: 'no-repeat',
                backgroundSize:"cover",
            }}>
                <Box className="elevateHeaderContent">
                        <Typography className="elevateHeaderText">
                            START YOUR<br/>
                            CHILD ONLINE<br/>
                            PROTECTION JOURNEY
                        </Typography>
                </Box>
            </Box>

            <Box className="sectionEmpower" sx={{
                position: "relative",
                display: "flex",
                alignItems: "stretch",
                flexDirection: { xs: "column", md: "row" },
                width: "100%",
            }}>
                <Box
                    sx={{
                        flex: {lg:1.7},
                        backgroundColor: "#003C69",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: {xs:'flex-start', sm:"center"},
                        px: { xs: "20px", md: "40px" },
                        py: { xs: "40px", md: "80px" },
                    }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            color: "#fff",
                            fontSize: { xs: "23px", md:"50px", lg: "70px",},
                            fontWeight: "bold",
                            textAlign: { xs: "center", md: "left" },
                            marginLeft:{xs:'0px', lg:'80px'},
                        }}
                    >
                        BASELINE TO BREAKTHROUGH
                    </Typography>
                </Box>
                <Box
                    sx={{
                        flex: {lg:2},
                        backgroundColor: "#fff",
                        display: "flex",
                        alignItems: "center",
                        px: { xs: "20px", md:'50px', lg: "100px" },
                        py: { xs: "40px", md: "80px" },
                    }}
                >
                    <Typography
                        sx={{
                            color: "#003C69",
                            fontSize: { xs: "17px", sm: "25px" },
                            textAlign: "left",
                        }}
                    >
                        An alarming <b>76% of children aged 8–18 faced</b> at least one cyber risk in 2023–2025, up from 72% during the COVID19
                        pandemic—and largely unchanged for nearly a decade. With AI accelerating new threats, this stagnation demands urgent
                        national action.<br/><br/>
                        The <b>CPC Index </b>provides the clear, data-driven framework needed to track your nation's progress and guide strategic action.
                        Your journey from baseline to breakthrough starts with knowing where you stand.
                    </Typography>
                </Box>
            </Box>

            <Box sx={{
                textAlign: 'center',
                backgroundColor: '#007DB4',
                color: '#fff',
                p: {xs: '20px', sm: 8},
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {loading ? (
                    <Skeleton
                        variant="text"
                        width={600}
                        height={150}
                        sx={{mb: 5}}
                    />
                ) : (
                    <Typography variant="h2" sx={{
                        color: '#fff',
                        fontSize: {xs: '25px', sm: '25px', md: '35px', lg: '3.5rem'},
                        fontWeight: 'bold',
                        mt: 7,
                        mb: 10
                    }}>
                        4 STEPS TO TRACK YOUR <br/>CHILD ONLINE PROTECTION PROGRESS
                    </Typography>
                )}
                <Grid container spacing={3} sx={{
                    mb: 6,
                    flexWrap: {xs: 'nowrap'},
                    pl: {xs: '0px', md:'0px'},
                    justifyContent: {xs: 'flex-start',md:'space-between', lg: 'center'},
                    overflow: {xs: 'scroll', md: 'scroll', lg: 'unset'}
                }}>
                    <Grid item xs={12} sm={6} md={2}>
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={100}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="h2" sx={{mb: 3, fontSize: '3.9rem', fontWeight: 'bold'}}>
                                1
                            </Typography>)}

                        {loading ? (
                            <Skeleton
                                variant="circular"
                                width={100}
                                height={100}
                                sx={{marginBottom: 2}}
                            />) : (
                            <Box
                                component="img"
                                src={Icon1}
                                alt="Step 1"
                                sx={{
                                    maxHeight: {xs: "88px",md:'115px', lg: "150px"},
                                    objectFit: "cover",
                                }}
                            />
                        )}
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={200}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="body1" sx={{
                                margin: {xs:'10px 0px', sm:'40px 10px'},
                                fontSize: {xs: '16px',md:'25px', lg: '30px'},
                                lineHeight: '1.2'
                            }}>Know Your Nation’s Child Cyber Risks Profile</Typography>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={100}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="h2" sx={{mb: 3, fontSize: '3.9rem', fontWeight: 'bold'}}>
                                2
                            </Typography>)}
                        {loading ? (
                            <Skeleton
                                variant="circular"
                                width={100}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Box
                                component="img"
                                src={Icon3}
                                alt="Step 2"
                                sx={{
                                    maxHeight: {xs: "80px",md:'110px', lg: "140px"},
                                    objectFit: "cover",
                                    marginBottom: {xs:'15px',sm:'9px', md:'9px', lg:'15px'},
                                }}
                            />
                        )}
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={200}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="body1" sx={{
                                margin: {xs:'10px 0px', sm:'40px 10px'},
                                fontSize: {xs: '16px',md:'25px', lg: '30px'},
                                lineHeight: '1.2'
                            }}>Assess Your Children’s Cyber Citizenship Levels
                            </Typography>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={100}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="h2" sx={{mb: 3, fontSize: '3.9rem', fontWeight: 'bold'}}>
                                3
                            </Typography>)}
                        {loading ? (
                            <Skeleton
                                variant="circular"
                                width={100}
                                height={100}
                                sx={{marginBottom: '21px'}}
                            />
                        ) : (
                            <Box
                                component="img"
                                src={Icon2}
                                alt="Step 2"
                                sx={{
                                    maxHeight: {xs: "78px",md:'110px', lg: "140px"},
                                    objectFit: "cover",
                                    marginBottom: {xs:'21px',sm:'10px', md:'10px', lg:'21px'},
                                }}
                            />
                        )}
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={200}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="body1" sx={{
                                margin: {xs:'10px 0px', sm:'40px 10px'},
                                fontSize: {xs: '16px',md:'25px', lg: '30px'},
                                lineHeight: '1.2'
                            }}>Review Your Nation’s Overall CPC Index Baseline
                            </Typography>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={100}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="h2" sx={{mb: 3, fontSize: '3.9rem', fontWeight: 'bold'}}>
                                4
                            </Typography>)}
                        {loading ? (
                            <Skeleton
                                variant="circular"
                                width={100}
                                height={100}
                                sx={{marginBottom: '21px'}}
                            />
                        ) : (
                            <Box
                                component="img"
                                src={Icon4}
                                alt="Step 4"
                                sx={{
                                    maxHeight: {xs: "78px",md:'110px', lg: "140px"},
                                    objectFit: "cover",
                                    marginBottom: {xs:'21px',sm:'10px', md:'10px', lg:'21px'},
                                }}
                            />)}
                        {loading ? (
                            <Skeleton
                                variant="text"
                                width={200}
                                height={100}
                                sx={{marginBottom: 2}}
                            />
                        ) : (
                            <Typography variant="body1" sx={{
                                margin: {xs:'10px 0px', sm:'40px 10px'},
                                fontSize: {xs: '16px',md:'25px', lg: '30px'},
                                lineHeight: '1.2'
                            }}>Identify Gaps Across All Stakeholders</Typography>
                        )}
                    </Grid>
                </Grid>
            </Box>

            {/*1. SET A GOAL SECTION*/}

            <Box sx={{padding: {xs: '40px 20px',md: '40px', lg: '100px 50px 60px 90px'},}}>
                <Typography variant="h3" sx={{fontSize: {xs: '23px', md:'35px',}, color: '#003C69', fontWeight: 'bold', mb: 1}}>
                    1. KNOW YOUR NATION’S CHILD CYBER RISKS PROFILE
                </Typography>
                <Typography variant="h5" sx={{fontSize: {xs: '17px', md:'25px'}, color: '#003C69', paddingBottom: '50px'}}
                            gutterBottom>
                    See your nation’s child cyber risk prevalence.
                </Typography>

                <Grid container spacing={4} sx={{display: 'flex', justifyContent: 'space-between',}}>
                    <Grid item xs={12} md={3} lg={3} mt='2%' mb='auto'>
                        <Box sx={{
                            width: '100%',
                            backgroundColor: '#003C69',
                            borderRadius: '20px',
                            p: {xs:4, lg:'60px 20px'},
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}>
                            <Typography variant="h4" sx={{color: '#fff', fontWeight: 'bold', fontSize: {xs:'20px', md:'25px', lg:'30px'}, lineHeight: '1.2', mx: 2, mb: 2,}}>
                                YOUR NATION’S CHILD <br/> CYBER RISKS PREVALENCE:
                            </Typography>
                            <Box sx={{
                                backgroundColor: '#003C69',
                                color: '#fff',
                                fontSize: '60px',
                                fontWeight: 'bold',
                                borderRadius: '0px',
                                px: 4,
                                display: 'inline-block',
                            }}>
                                {selectedCountryA1OverAllCyberRisk === "NA" ? "NA" : `${selectedCountryA1OverAllCyberRisk}%`}
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={9} lg={9} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: {xs: 'column', sm: 'row'},
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            backgroundColor: '#E9ECEF',
                            minWidth: '90%',
                            borderRadius: '0px',
                            padding: '10px 30px',
                            mb: 2,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '5px',
                                mb: 2,
                            }}>
                                <Typography variant="body1" sx={{fontWeight: 'bold'}}>My Country</Typography>
                                <Autocomplete
                                    id="country-a-select"
                                    options={digitalGapsCountries || []}
                                    getOptionLabel={(option) => option.label}
                                    value={selectedCountryA1}
                                    onChange={(event, newValue) => handleCountryChange(newValue, "A", 1)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            placeholder="Select Country"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                    height: '40px',
                                                    paddingY: '0px',
                                                },
                                            }}
                                            sx={{
                                                '& fieldset': {
                                                    border: '1px solid #003C69',
                                                    borderRadius: '0px',

                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '6px 12px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    color: '#003C69',
                                                    '&::placeholder': {
                                                        color: 'grey',
                                                        fontWeight: 'normal',
                                                    },
                                                },
                                            }}
                                        />
                                    }
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            color: '#0096C8',
                                            fontSize: '25px',
                                        },
                                        width: {xs:'230px',md: '130px', lg:'230px'},
                                        backgroundColor: '#fff',
                                        borderRadius: '0px',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        minWidth: '130px',
                                    }}
                                />
                            </Box>
                            <Typography variant="body1" sx={{
                                margin: {xs: '0px', sm: '30px 20px 20px 20px'},
                                color: 'grey'
                            }}>VS</Typography>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '5px',
                                mb: 2,
                            }}>
                                <Typography variant="body1" sx={{fontWeight: 'bold'}}>Other Country</Typography>
                                <Autocomplete
                                    id="country-b-select"
                                    options={digitalGapsCountries || []}
                                    getOptionLabel={(option) => option.label}
                                    value={selectedCountryB1}
                                    onChange={(event, newValue) => handleCountryChange(newValue, "B", 1)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            placeholder="Select Country"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                    height: '40px',
                                                    paddingY: '0px',
                                                },
                                            }}
                                            sx={{
                                                '& fieldset': {
                                                    border: '1px solid #003C69',
                                                    borderRadius: '0px',

                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '6px 12px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    color: '#0096C8',
                                                    '&::placeholder': {
                                                        color: 'grey',
                                                        fontWeight: 'normal',
                                                    },
                                                },
                                            }}
                                        />
                                    }
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            color: '#0096C8',
                                            fontSize: '25px',
                                        },
                                        width: {xs:'230px',md: '130px', lg:'230px'},
                                        backgroundColor: '#fff',
                                        borderRadius: '0px',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        minWidth: '130px',
                                    }}
                                />
                            </Box>
                            <Divider orientation="vertical" variant="middle" sx={{
                                display: {xs: 'none'}, marginLeft: '50px', marginRight: '30px', mb: '0px',
                                borderWidth: '1px', height: '70px', borderColor: '#979797'
                            }}/>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '5px',
                                mb: 2,
                            }}>
                                <Typography variant="body1" sx={{fontWeight: 'bold'}}>Age Group</Typography>
                                <Autocomplete
                                    id="age-group-select"
                                    options={AGE_GROUPS}
                                    onChange={handleAgeGroupChange}
                                    value={selectedAgeGroup}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                                   placeholder="Select Age Group"
                                                   InputProps={{
                                                       ...params.InputProps,
                                                       sx: {
                                                           height: '40px',
                                                           paddingY: '0px',
                                                       },
                                                   }}
                                                   sx={{
                                                       '& fieldset': {
                                                           border: '1px solid #003C69',
                                                           borderRadius: '0px',

                                                       },
                                                       '& .MuiInputBase-input': {
                                                           padding: '6px 12px',
                                                           fontWeight: 'bold',
                                                           color: 'grey',
                                                           textAlign: 'center',
                                                           '&::placeholder': {
                                                               color: 'grey',
                                                               fontWeight: 'normal',
                                                           },
                                                       },
                                                   }}
                                        />
                                    }
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            color: '#0096C8',
                                            fontSize: '25px',
                                        },
                                        width: {xs:'230px',md: '130px', lg:'230px'},
                                        backgroundColor: '#fff',
                                        borderRadius: '0px',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        minWidth: '130px',
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box sx={{overflowX: 'auto', width: '100%',}}>
                            <MixedChart key={JSON.stringify(mixedChartData1)} height="400px" chartData={mixedChartData1}
                                        showPercentage={true} isLoading={loading} yAxisLabel="% of Children at Risk"/>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/*2. CHILDREN CYBER CITIZENSHIP SECTION*/}

            <Box sx={{padding: {xs: '40px 20px', md: '75px 40px', lg: '75px 85px'}, backgroundColor: '#E9ECEF',}}>
                <Grid container
                      sx={{display: 'flex', flexDirection: 'column', mt: '50px', justifyContent: 'space-between',}}>
                    {/* Left Section Title */}
                    <Grid item sx={{alignSelf: 'top', width: {xs: '100%'}}}>
                        <Typography variant="h3" sx={{fontSize: {xs: '23px', md:'35px',}, color: '#003C69', fontWeight: 'bold', mb: 1}}>
                            2. ASSESS YOUR CHILDREN’S CYBER CITIZENSHIP COMPETENCIES
                        </Typography>
                        <Typography variant="h5" sx={{fontSize: {xs: '17px',md:'25px', lg: '25px'},mb:4, color: '#003C69',}} gutterBottom>
                            Empowering children with Cyber Citizenship Competencies is the key to reducing national cyber risks. We measure this through the Cyber Citizenship Competency Score,
                            which is based on CPC Index Indicators 01–15. This score assesses proficiency across three Target areas: Basic Cybersecurity and Privacy Management, Cyber Safety
                            Management, and Cyber Civility.
                        </Typography>
                    </Grid>
                    {/* Right Column */}
                    <Grid item sx={{
                        display: 'flex',
                        paddingLeft: {xs: '0px', md:'0px', lg: '30px'},
                        width: {xs: '100%'},
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        {/* Country Info Box */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: {xs: 'column', sm: 'row'},
                            width: {xs: '78%', sm: '80%'},
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            minWidth: '80%',
                            borderRadius: '0px',
                            border: '2px solid #fff',
                            padding: '10px 30px',
                            mb: 2,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '5px',
                                mb: 2,
                            }}>
                                <Typography variant="body1" sx={{fontWeight: 'bold'}}>My Country</Typography>
                                <Autocomplete
                                    id="country-a-select"
                                    options={cyberCitizenshipCountries || []}
                                    getOptionLabel={(option) => option.label}
                                    value={selectedCountryA2}
                                    onChange={(event, newValue) => handleCountryChange(newValue, "A", 2)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            placeholder="Select Country"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                    height: '40px',
                                                    paddingY: '0px',
                                                },
                                            }}
                                            sx={{
                                                '& fieldset': {
                                                    border: '1px solid #003C69',
                                                    borderRadius: '0px',

                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '6px 12px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    color: '#003C69',
                                                    '&::placeholder': {
                                                        color: 'grey',
                                                        fontWeight: 'normal',
                                                    },
                                                },
                                            }}
                                        />
                                    }
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            color: '#0096C8',
                                            fontSize: '25px',
                                        },
                                        width: {xs:'230px',md: '130px', lg:'230px'},
                                        backgroundColor: '#fff',
                                        borderRadius: '0px',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        minWidth: '130px',
                                    }}
                                />
                            </Box>
                            <Typography variant="body1" sx={{
                                margin: {xs: '0px', sm: '30px 20px 20px 20px'},
                                color: 'grey'
                            }}>VS</Typography>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '5px',
                                mb: 2,
                            }}>
                                <Typography variant="body1" sx={{fontWeight: 'bold'}}>Other Country</Typography>
                                <Autocomplete
                                    id="country-b-select"
                                    options={cyberCitizenshipCountries || []}
                                    getOptionLabel={(option) => option.label}
                                    value={selectedCountryB2}
                                    onChange={(event, newValue) => handleCountryChange(newValue, "B", 2)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            placeholder="Select Country"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                    height: '40px',
                                                    paddingY: '0px',
                                                },
                                            }}
                                            sx={{
                                                '& fieldset': {
                                                    border: '1px solid #003C69',
                                                    borderRadius: '0px',

                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '6px 12px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    color: '#0096C8',
                                                    '&::placeholder': {
                                                        color: 'grey',
                                                        fontWeight: 'normal',
                                                    },
                                                },
                                            }}
                                        />
                                    }
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            color: '#0096C8',
                                            fontSize: '25px',
                                        },
                                        width: {xs:'230px',md: '130px', lg:'230px'},
                                        backgroundColor: '#fff',
                                        borderRadius: '0px',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        minWidth: '130px',
                                    }}
                                />
                            </Box>
                            <Divider orientation="vertical" variant="middle" sx={{
                                display: {xs: 'none', sm: 'block'}, marginLeft: '50px', marginRight: '30px', mb: '0px',
                                borderWidth: '1px', height: '70px', borderColor: '#979797'
                            }}/>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '5px',
                                mb: 2,
                            }}>
                                <Typography variant="body1" sx={{fontWeight: 'bold'}}>Age Group</Typography>
                                <Autocomplete
                                    id="age-group-select"
                                    options={AGE_GROUPS}
                                    onChange={handleAgeGroupChange2}
                                    value={selectedAgeGroup2}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                                   placeholder="Select Age Group"
                                                   InputProps={{
                                                       ...params.InputProps,
                                                       sx: {
                                                           height: '40px',
                                                           paddingY: '0px',
                                                       },
                                                   }}
                                                   sx={{
                                                       '& fieldset': {
                                                           border: '1px solid #003C69',
                                                           borderRadius: '0px',

                                                       },
                                                       '& .MuiInputBase-input': {
                                                           padding: '6px 12px',
                                                           fontWeight: 'bold',
                                                           color: 'grey',
                                                           textAlign: 'center',
                                                           '&::placeholder': {
                                                               color: 'grey',
                                                               fontWeight: 'normal',
                                                           },
                                                       },
                                                   }}
                                        />
                                    }
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            color: '#0096C8',
                                            fontSize: '25px',
                                        },
                                        width: {xs:'230px',md: '130px', lg:'230px'},
                                        backgroundColor: '#fff',
                                        borderRadius: '0px',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        minWidth: '130px',
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box sx={{
                            marginTop: '30px',
                            width: '95%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            gap: '30px'
                        }}>
                            <Grid item sx={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                alignItems: {xs: 'center'},
                                flexDirection: {xs: 'column', sm: 'row'},
                                width: {xs: '100%', sm: '800px'},
                                gap: 1
                            }}>
                                {/* Singapore Average */}
                                <Box sx={{
                                    height: '120px',
                                    display: 'flex',
                                    width: '220px',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#003C69',
                                    color: '#fff',
                                    borderRadius: '0px',
                                    px: 2,
                                    py: 3,
                                }}>
                                    <Typography variant="h7" sx={{
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        textTransform: 'uppercase',
                                        lineHeight: '1.2'
                                    }}>
                                        {selectedCountryA2 ? selectedCountryA2.label : 'SINGAPORE'} <br/> AVERAGE
                                    </Typography>
                                    <Typography variant="h5" sx={{fontWeight: 'bold', lineHeight: '1.2', mt: 1}}>
                                        {selectedCountryA2Avg ? selectedCountryA2Avg : ''}
                                    </Typography>
                                </Box>
                                {/* France Average */}
                                <Box sx={{
                                    height: '120px',
                                    display: 'flex',
                                    width: '220px',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#0096C8',
                                    color: '#fff',
                                    borderRadius: '0px',
                                    px: 2,
                                    py: 3,
                                }}>
                                    <Typography variant="h7" sx={{
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        textTransform: 'uppercase',
                                        lineHeight: '1.2'
                                    }}>
                                        {selectedCountryB2 ? selectedCountryB2.label : 'FRANCE'} <br/> AVERAGE
                                    </Typography>
                                    <Typography variant="h5" sx={{fontWeight: 'bold', lineHeight: '1.2', mt: 1}}>
                                        {selectedCountryB2Avg ? selectedCountryB2Avg : ''}
                                    </Typography>
                                </Box>
                                {/* Global Average */}
                                <Box sx={{
                                    height: '120px',
                                    display: 'flex',
                                    width: '220px',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#F0605C',
                                    color: '#fff',
                                    borderRadius: '0px',
                                    px: 2,
                                    py: 3,
                                }}
                                >
                                    <Typography variant="h7"
                                                sx={{fontWeight: 'bold', textAlign: 'center', lineHeight: '1.2'}}>
                                        GLOBAL <br/> AVERAGE
                                    </Typography>
                                    <Typography variant="h5" sx={{fontWeight: 'bold', lineHeight: '1.2', mt: 1}}>
                                        {globalAvg2 ? globalAvg2 : ''}
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item sx={{overflowX: 'auto', width: '100%', mt: '25px'}}>
                                <MixedChart key={JSON.stringify(mixedChartData2)} height="500px"
                                            chartData={mixedChartData2} isLoading={loading} showPercentage={false}
                                            yAxisLabel="Cyber Citizenship Score"/>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/*3. NATION’S CPC Index SECTION*/}

            <Box id="nationCPCI" sx={{backgroundColor: '#fff', padding: {xs: '40px 30px', md: '100px 40px', lg: '100px 90px'},}}>
                {/* Title and Subtitle */}
                <Typography variant="h3" sx={{fontSize: {xs: '23px', md:'35px'}, color: '#003C69', fontWeight: 'bold', mb: 1}}>
                    3. REVIEW YOUR NATION’S OVERALL CPC INDEX BASELINE
                </Typography>
                <Typography variant="h5" sx={{fontSize: {xs: '17px', md:'25px', lg:'25px'}, color: '#003C69', paddingBottom: '50px'}}
                            gutterBottom>
                    Examine your nation’s CPC Index scores to understand strengths, pinpoint weaknesses, and see how you compare to the global benchmark.
                </Typography>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}
                          sx={{display: 'flex', paddingTop: '0px', flexDirection: 'column', alignItems: 'center'}}>
                        <Autocomplete
                            id="country-select-demo"
                            options={cpciCountries}
                            autoHighlight
                            getOptionLabel={(option) => option.label}
                            value={selectedCountryA3}
                            onChange={(event, newValue) => handleCountryChangeCPCI(newValue)}
                            renderOption={(props, option) => {
                                const {key, ...optionProps} = props;
                                return (
                                    <Box
                                        key={key}
                                        component="li"
                                        sx={{'& > img': {mr: 2, flexShrink: 0}}}
                                        {...optionProps}
                                    >
                                        <img
                                            loading="lazy"
                                            width="20"
                                            src={require(`../../assets/flags-w80/${option.code.toLowerCase()}.png`)}
                                            alt=""
                                        />
                                        {option.label} ({option.code})
                                    </Box>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Choose a country"
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                            height: '40px',
                                            paddingY: '0px',
                                        },
                                    }}
                                    slotProps={{
                                        htmlInput: {
                                            ...params.inputProps,
                                            autoComplete: 'new-password',
                                        },
                                    }}
                                    sx={{
                                        '& fieldset': {
                                            border: '1px solid #003C69',
                                            borderRadius: '0px',
                                            color: '#003C69',
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: '6px 12px',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                            color: '#003C69',
                                            '&::placeholder': {
                                                color: 'grey',
                                                fontWeight: 'normal',
                                            },
                                        },
                                    }}
                                />
                            )}
                            sx={{
                                '& .MuiSvgIcon-root': {
                                    color: '#0096C8',
                                    fontSize: '25px',
                                },
                                width: '220px',
                                marginBottom: '40px',
                                color: '#003C69',
                                borderRadius: '0px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                minWidth: '130px',
                            }}
                        />

                        <Box sx={{width: '100%', mt: {xs: '-40px', sm: 5}}}>
                            <RadarChart data={nationCpciData} isLoading={loading}/>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <CPCITable cpciTableData={cpciTableData} country={selectedCountryA3.label}/>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                mt: 4,
                                p: 2,
                                width: "108%",
                                background: '#fff',
                                marginTop: '-2px',
                                borderRadius: '0px',
                                marginLeft: {xs: '-15px', sm: '-30px'},
                                border: '1px solid #295F93',
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                    width: "18%",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 22,
                                        height: 22,
                                        borderRadius: "50%",
                                        backgroundColor: "#03AF9A",
                                        mb: '3px',
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "#003C69",
                                        fontSize: {xs: '6px', sm: "13px"},
                                        fontWeight: 'bold',
                                        mb: '3px',
                                    }}
                                >
                                    EXCEPTIONAL
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontSize: {xs: '9px', sm: "13px"},
                                    lineHeight: '1.2',
                                    color: "#5F6162"
                                }}>
                                    World-class performance, exceeding global benchmarks
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                    width: "18%",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 22,
                                        height: 22,
                                        borderRadius: "50%",
                                        backgroundColor: "#8269D2",
                                        mb: '3px',
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "#003C69",
                                        fontSize: {xs: '6px', sm: "13px"},
                                        fontWeight: 'bold',
                                        mb: '3px',
                                    }}
                                >
                                    EFFECTIVE
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontSize: {xs: '9px', sm: "13px"},
                                    lineHeight: '1.2',
                                    color: "#5F6162"
                                }}>
                                    Consistently meets most targets with minor gaps
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                    width: "18%",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 22,
                                        height: 22,
                                        borderRadius: "50%",
                                        backgroundColor: "#EBB941",
                                        mb: '3px',
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "#003C69",
                                        fontSize: {xs: '6px', sm: "13px"},
                                        fontWeight: 'bold',
                                        mb: '3px',
                                    }}
                                >
                                    MODERATE
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontSize: {xs: '9px', sm: "13px"},
                                    lineHeight: '1.2',
                                    color: "#5F6162"
                                }}>
                                    Consistently meets most targets with minor gaps
                                </Typography>
                            </Box>

                            {/* EMERGING */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                    width: "18%",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 22,
                                        height: 22,
                                        borderRadius: "50%",
                                        backgroundColor: "#F05E63",
                                        mb: '3px',
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "#003C69",
                                        fontSize: {xs: '6px', sm: "13px"},
                                        fontWeight: 'bold',
                                        mb: '3px',
                                    }}
                                >
                                    EMERGING
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontSize: {xs: '9px', sm: "13px"},
                                    lineHeight: '1.2',
                                    color: "#5F6162"
                                }}>
                                    Significant gaps exist, requiring urgent action
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                    width: "18%",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 22,
                                        height: 22,
                                        borderRadius: "50%",
                                        backgroundColor: "#003C69",
                                        mb: '3px',
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "#003C69",
                                        fontSize: {xs: '6px', sm: "13px"},
                                        fontWeight: 'bold',
                                        mb: '3px',
                                    }}
                                >
                                    DATA UNAVAILABLE
                                </Typography>
                                <Typography variant="body1" sx={{
                                    fontSize: {xs: '9px', sm: "13px"},
                                    lineHeight: '1.2',
                                    color: "#5F6162"
                                }}>
                                    Insufficient data for assessment
                                </Typography>
                            </Box>
                        </Box>
                        <Typography variant="body1" sx={{
                            fontSize: "15px",
                            px: {xs:'0px',sm:"50px"},
                            textAlign: 'center',
                            lineHeight: '1.2',
                            mt: 2,
                            color: "#000000"
                        }}>
                            If your nation’s data is incomplete or you wish to amend your score, we welcome you to {' '}
                            <Link
                                href="mailto:Info@gcforum.org"
                                style={{ color: '#000000', fontWeight: 'bold', textDecoration: 'underline' }}
                            >
                                contact us
                            </Link>
                            {' '}to ensure the most accurate representation of progress.

                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            {/*4. FOSTER COLLABORATIVE EFFORTS SECTION*/}

            <Box sx={{padding: {xs: '40px 20px', md: '80px 40px 150px 40px', lg: '80px 40px 150px 90px'}, backgroundColor: '#E9ECEF',}}>
                <Grid container spacing={3} sx={{display: 'flex', justifyContent: 'space-between'}}>
                    {/* Left Section Title */}
                    <Grid item xs={12} md={3} sx={{alignSelf: 'top', mt: 9}}>
                        <Typography variant="h3"
                                    sx={{fontSize: {xs: '23px', md:'35px'}, color: '#003C69', fontWeight: 'bold', mb: 1}}>
                            4. IDENTIFY GAPS ACROSS ALL STAKEHOLDERS
                        </Typography>
                        <Typography variant="h5" sx={{fontSize: {xs: '17px', sm:'25px'}, color: '#003C69', paddingBottom: '30px'}} gutterBottom>
                            Identify areas for improvement across all key stakeholders to close gaps and strengthen child protection in Cyberspace efforts.
                        </Typography>

                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, margin: {xs:'0 55px', sm:'0px', lg:'0 55px'}}}>
                            {[
                                {text: 'Exceptional', bgColor: '#03AF9A'},
                                {text: 'Effective', bgColor: '#8269D2'},
                                {text: 'Moderate', bgColor: '#EBB941'},
                                {text: 'Emerging', bgColor: '#F05E63'},
                                {text: 'Data Unavailable', bgColor: '#003C69'},
                            ].map((quartile, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: quartile.bgColor,
                                            color: '#fff',
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: 'bold',
                                            fontSize: '18px',
                                            flexShrink: 0,
                                            position: 'absolute',
                                            zIndex: 3,
                                        }}
                                    >
                                    </Box>

                                    <Box sx={{
                                        flex: 1,
                                        backgroundColor: '#ffff',
                                        minWidth: '200px',
                                        height: '35px',
                                        borderRadius: '0px',
                                        position: 'relative',
                                        marginLeft: '7px',
                                    }}>
                                        <Typography sx={{
                                            position: 'absolute',
                                            top: '5px',
                                            left: '10px',
                                            color: '#00000',
                                            fontWeight: '500',
                                            marginLeft: '50px',
                                        }}>
                                            {quartile.text}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={12} md={8} sx={{alignSelf: 'center',}}>
                        <Grid container sx={{display: 'flex', overflowX: { xs: "auto", sm: "unset" }, flexDirection: 'column'}}>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'end',
                                justifyContent: 'flex-end',
                                marginBottom: '8px',
                                minWidth: { xs: "400px", sm: "100%" },
                            }}
                            >
                                <Typography sx={{
                                    color: '#003C69',
                                    textAlign: 'center',
                                    fontSize: {xs: '8px', sm: '15px'},
                                    lineHeight: '1.2',
                                    width: {xs: '100px', sm: '215px'},
                                    fontWeight: 'bold',
                                    marginRight: {xs: '6px', sm: '0'},
                                }}>National Level</Typography>
                            </Box>
                            {Object.keys(STAKEHOLDERS_CATEGORY_COLOR_MAPPING).map((categoryName, catIndex) => {
                                const categoryColor = STAKEHOLDERS_CATEGORY_COLOR_MAPPING[categoryName];
                                const categorySections = stakeholdersData.filter(
                                    section => section.category === categoryName
                                );
                                return (
                                <Box key={catIndex} sx={{ display: 'flex', width: '100%', mb: '6px' }}>

                                    {/* Category Cell with vertical text */}
                                    <Box
                                        sx={{
                                            backgroundColor: categoryColor,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                writingMode: 'vertical-rl',
                                                textOrientation: 'mixed',
                                                transform: 'rotate(180deg)',
                                                borderRadius: '0px',
                                                px: 1,
                                                py: 2,
                                                minWidth: {xs:'65px', sm:'90px'},
                                                marginRight:'6px',
                                        }}
                                        >
                                        <Typography sx={{ fontWeight: 'bold', fontSize: { xs: '14px', sm: '16px' }, color: '#fff', height:{xs:'100px', sm:'auto'}, textAlign:'center'}}>
                                            {categoryName}
                                        </Typography>
                                        </Box>

                                        {/* Stakeholders inside this category */}
                                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px',   height: '100%',
                                            alignSelf: 'stretch', }}>
                                            {categorySections.map((section, index) => (
                                                <Box key={index} sx={{ display: 'flex', alignItems: 'stretch', gap: '10px' }}>

                                                    {/* Icon + Title box */}
                                                    <Box
                                                        sx={{
                                                            backgroundColor: categoryColor,
                                                            color: '#fff',
                                                            fontWeight: 'bold',
                                                            textAlign: 'center',
                                                            borderRadius: '0px',
                                                            px: {xs: 0, sm: 2},
                                                            py: {xs: '12px', sm: 3},
                                                            width: {xs: '100px', sm: '178px'},
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginBottom: '1px',
                                                            zIndex: 3,
                                                            minHeight: {xs: '131px', sm: '183px'},
                                                        }}>
                                        <Box
                                            component="img"
                                            src={section.icon}
                                            sx={{
                                                height: {xs: '40px', sm: '65px'},
                                                objectFit: 'contain',
                                            }}
                                        />
                                        <Typography variant="body1" sx={{
                                            fontSize: {xs: '0.7rem', sm: '1rem'},
                                            color: '#fff',
                                            fontWeight: 'bold',
                                            wordWrap: 'break-word',
                                            textAlign: 'center'
                                        }}>
                                            {section.title}
                                        </Typography>
                                    </Box>


                                    <Box sx={{
                                        flex: 4,
                                        marginLeft: {xs: '-27px', sm: '-30px'},
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '0px',
                                        minHeight: '100%'
                                    }}>

                                        {section.rows.map((row, rowIndex) => (
                                            <Box
                                                key={rowIndex}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    height: '100%',
                                                    border: '1px solid #E0E0E0',
                                                    borderRadius: '0px',
                                                    padding: {xs: '0 0 0 12px', sm: '0 12px'},
                                                    minWidth: {xs: '230px', sm: 'auto'},
                                                    backgroundColor: '#fff',
                                                    flex: 1,
                                                    wordWrap: 'break-word',
                                                }}
                                            >
                                                <Typography sx={{
                                                    color: '#003C69',
                                                    marginLeft: {xs: '15px', md:'0px', lg: '25px'},
                                                    lineHeight: {xs: ' 1', sm: '1.3'},
                                                    fontSize: {xs: '0.5rem',md:'0.7rem', lg: '0.9rem'},
                                                    fontWeight: 'regular',
                                                    whiteSpace: 'normal',
                                                    wordWrap: 'break-word',
                                                    flex: 1
                                                }}
                                                >
                                                    {row.text}</Typography>
                                                <Box sx={{display: 'flex', alignItems: 'center',}}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginRight: {xs: '0', sm: '20px'},
                                                        paddingRight:{xs:'10px', sm: undefined},
                                                        gap: '3px'
                                                    }}>
                                                        {[0, 1, 2, 3, 4].map((circleIndex) => (
                                                            <Box
                                                                key={circleIndex}
                                                                sx={{
                                                                    width: {xs: '10px', sm: '25px'},
                                                                    height: {xs: '10px', sm: '25px'},
                                                                    borderRadius: '50%',
                                                                    backgroundColor:
                                                                        row.circleColor === '#003C69' && circleIndex === 0
                                                                            ? '#003C69'
                                                                            : row.circleColor === '#F05E63' && circleIndex === 1
                                                                                ? '#F05E63'
                                                                                : row.circleColor === '#EBB941' && circleIndex === 2
                                                                                    ? '#EBB941'
                                                                                    : row.circleColor === '#8269D2' && circleIndex === 3
                                                                                        ? '#8269D2'
                                                                                        : row.circleColor === '#03AF9A' && circleIndex === 4
                                                                                            ? '#03AF9A'
                                                                                            : '#E9ECEF',
                                                                }}
                                                            />
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}
                                    </Box>
                                 </Box>
                                );
                            })}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid sx={{display: 'flex', flexDirection:{xs:'column', sm:'row'}, justifyContent: 'center', gap:{xs:'20px', sm:'100px'}}}>
                    <Box sx={{display: 'flex', justifyContent: 'center', mt:{xs:'50px',sm:'100px'}}}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                history.push('/global_cpc');
                                setTimeout(() => {
                                    const element = document.getElementById('homeContactSection');
                                    if (element) {
                                        element.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start'
                                        });
                                    }
                                }, 500);
                            }}
                            sx={{
                                backgroundColor: '#003C69',
                                color: '#fff',
                                borderRadius: '0px',
                                fontSize: {xs:'18px', sm:'22px'},
                                fontWeight: 'bold',
                                px: 9,
                                '&:hover': {backgroundColor: '#003C69'},
                            }}
                        >
                           JOIN THE CPC INDEX
                        </Button>
                    </Box>

                    <Box sx={{display: 'flex', justifyContent: 'center', mt:{xs:'0',sm:'100px'}}}>
                        <Button
                            variant="contained"
                            onClick={() => history.push('/methodology')}
                            sx={{
                                backgroundColor: '#003C69',
                                color: '#fff',
                                borderRadius: '0px',
                                fontSize: {xs:'18px', sm:'22px'},
                                fontWeight: 'bold',
                                px: 7,
                                '&:hover': {backgroundColor: '#003C69'},
                            }}
                        >
                            SEE THE METHODOLOGY
                        </Button>
                    </Box>
                </Grid>
            </Box>
            <Footer/>
        </Box>
    );
};

export default NationalCPC;